import { render, staticRenderFns } from "./GiftPreviewTab.vue?vue&type=template&id=af6c335c"
import script from "./GiftPreviewTab.vue?vue&type=script&lang=js"
export * from "./GiftPreviewTab.vue?vue&type=script&lang=js"
import style0 from "./GiftPreviewTab.vue?vue&type=style&index=0&id=af6c335c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports